<template>
  <div class="guanggaocard has-text-left">
    <span class="tag is-white guangaoicon">广告</span>
    <!-- <h1>{{adname }}</h1> -->
  </div>
</template>

<script>
export default {
  name: "AdCard",
  props: {
    adname: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variable.scss";
.guanggaocard {
  background-color: $ad-bg;
  color: black;
  // margin: 0.5em auto;
  padding: 0.5em;
  height: $height-guanggao;
}
// .guangaoicon {
// }
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
